import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import authService from '../../services/AuthService';
import './Login.css';

/**
 * Login.js
 *
 * This component starts the authentication flow by redirecting the user to the AWS Cognito hosted login UI.
 * It uses environment variables to construct the full login URL dynamically at runtime, allowing flexibility
 * across local, staging, and production environments.
 *
 * Environment variables used:
 * - REACT_APP_COGNITO: The Cognito domain of the User Pool
 * - REACT_APP_COGNITO_CLIENT_ID: The Cognito App/Client ID of the User Pool
 * - REACT_APP_RIPPLE: The app URL (this FE) where Cognito should return the user after login
 *
 * Once the login URL is built, the user is redirected to Cognito with the appropriate
 * client ID, response type, scope, and redirect URI parameters.
 *
 * The redirect URI must match exactly what's configured in Cognito's App Client settings.
 */


export class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            helpMessage: null,
            userName: null,
            password: null, 
            firstPage: null
        }

        authService.clearAuthenticated();
    }

    render() {
        // Redirect if already authenticated
        if (authService.isAuthenticated) {
            return <Redirect to={this.state.firstPage} />;
        }

        // Clear any existing session state
        authService.clearAuthenticated();

        // Environment variables
        const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
        const cognitoURL = process.env.REACT_APP_COGNITO;
        const rippleURL = process.env.REACT_APP_RIPPLE;

        // Constants for Cognito login 
        const responseType = 'token';
        const scope = 'aws.cognito.signin.user.admin openid phone profile';

        // Construct redirect and login URIs
        const loginUri = `${cognitoURL}/login`;
        const redirectUri = `${rippleURL}/cognitologin`;

        // Construct full login URL
        const loginUrl = `${loginUri}?client_id=${clientId}&response_type=${responseType}&scope=${encodeURIComponent(scope)}&redirect_uri=${encodeURIComponent(redirectUri)}`;

        // Redirect to Cognito login
        window.location.href = loginUrl;
    }

}

export default Login;




// WEBPACK FOOTER //
// ./src/components/Login/Login.js